<template>
    <div class="">
		 <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item"><router-link to="/schools">Schools</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <span v-if="status">New School</span>
                        <span v-else>Update School</span>
                    </li>
                </ol>
                <label class="form-label">
                    <h4 v-if="status">New School</h4>
                    <h4 v-else>Update School</h4>
                </label>
            </div>
             <router-link to="/schools" type="submit" class="btn d-flex align-item-center btn-primary"><i class="ri-list-check me-1"></i> SCHOOLS</router-link>
        </div>
        <form @submit.prevent="submitForm">
            <div class="card br-16 card-shadow">
                <div class="card-body mb-3">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <label class="form-label">School Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="School Name" class="form-control" :class="{ 'is-invalid': errors.school_name }" v-model="school.school_name" ref="school_name" />
                            <span v-if="errors.school_name" class="invalid-feedback">{{ errors.school_name }}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Board</label><span class="text-danger"> *</span>
                            <!-- <input type="text" placeholder="Board" class="form-control" :class="{ 'is-invalid': errors.board }" v-model="school.board"  /> -->
                            <select class="form-control" :class="{ 'is-invalid': errors.board }" v-model="school.board">
                                <option value="">Select Board</option>
                                <option value="CBSC">CBSC</option>
                                <option value="State">State</option>
                                <option value="ICSC">ICSC</option>
                            </select>
                            <span v-if="errors.board" class="invalid-feedback">{{ errors.board}}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">District</label><span class="text-danger"> *</span>
                            <Search
                                :class="{ 'is-invalid': errors?.district_id }"
                                :customClass="{ 'is-invalid': errors?.district_id }"
                                :initialize="school.district_id"
                                id="district_id"
                                label="district"
                                placeholder="Select District"
                                :data=" districts"
                                @input=" district => school.district_id = district"
                            >
                            </Search>
                            <span v-if="errors.district_id" class="invalid-feedback">{{ errors.district_id }}</span>
                        </div>
                          <div class="col-md-3">
                            <label class="form-label">Pin Code</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Pin Code" class="form-control" :class="{ 'is-invalid': errors.pincode }" v-model="school.pincode" />
                            <span v-if="errors.pincode" class="invalid-feedback">{{ errors.pincode}}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Principal</label>
                            <input type="text" placeholder="Principal" class="form-control" :class="{ 'is-invalid': errors.principal }" v-model="school.principal" />
                            <span v-if="errors.principal" class="invalid-feedback">{{ errors.principal}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Email</label>
                            <input type="text" placeholder="Email" class="form-control" :class="{ 'is-invalid': errors.email }" v-model="school.email" />
                            <span v-if="errors.email" class="invalid-feedback">{{ errors.email}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Phone Number</label>
                            <input type="text" placeholder="Phone Number" class="form-control" :class="{ 'is-invalid': errors.phone_number }" v-model="school.phone_number" />
                            <span v-if="errors.phone_number" class="invalid-feedback">{{ errors.phone_number}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Place</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Place" class="form-control" :class="{ 'is-invalid': errors.place }" v-model="school.place" />
                            <span v-if="errors.place" class="invalid-feedback">{{ errors.place}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Web Site</label>
                            <input type="text" placeholder="Web Site" class="form-control" :class="{ 'is-invalid': errors.web_site }" v-model="school.web_site" />
                            <span v-if="errors.web_site" class="invalid-feedback">{{ errors.web_site}}</span>
                        </div>
                         <div class="col-md-12">
                           <label class="form-label">Address</label><span class="text-danger"> *</span>
                                <textarea rows="2" type="text" placeholder="Address" class="form-control" v-model="school.address" :class="{ 'is-invalid': errors.address }"></textarea>
                                <span v-if="errors.address" class="invalid-feedback">{{ errors.address}}</span>
                        </div>
                        <div class="col-md-12">
                             <div class="text-end">
                                <button type="reset" class="btn btn-danger me-2" @click.prevent="discard()"><i class="ri-close-line icon_hgt"></i> DISCARD</button>
                                <button v-if="status" type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> SUBMIT</button>
                                <button v-else type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> UPDATE</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </form>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
    export default {
        name: "Schools.Create",
        components: {Search},
        data() {
            return {
                school: {
                    school_id: "",
                    school_name: "",
                    board: "",
                    district_id: "",
                    address: "",
                    place: "",
                    pincode: "",
                    principal: "",
                    email:"",
                    phone_number:"",
                    web_site:"",
                    user_id: this.$store?.getters?.user?.user_id
                },
                status: true,
                schools: [],
                districts:[],
                errors: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getDistrict();
                if (to.name == "Schools.Create") {
                    vm.$refs.school_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "school/viewSchool", data: { school_id: to.params.school_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.school = response.data.data;
                            vm.school.user_id = vm.$store?.getters?.user?.user_id
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
    methods: {
            getDistrict() {
				 let vm = this;
				let loader = vm.$loading.show();
				vm.$store.dispatch("post", { uri: "district/getDistricts" })
                .then((response) => {
                    console.log("distt",response.data.data)
                    loader.hide();
                    vm.districts = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
			},
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            create() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "school/addSchool", data: vm.school };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "School is successfully created");
                        vm.$router.push("/schools");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            update() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "school/updateSchool", data: vm.school };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "School is successfully updated");
                        vm.$router.push("/schools");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.school.school_name = "";
                vm.school.board = "";
                vm.school.district_id = "";
                vm.school.address = "";
                vm.school.place = "";
                vm.school.pincode = "";
                vm.school.school_strength = "";
                vm.$refs.school_name.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
